import React from "react";
import { Breadcrumb, Col, Container, Row } from "reactstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CompaniesTable from "./components/Companiestable";
import CompanyPartnerUsers from "./components/CompanyPartnerUsers";

function CompanyManagement() {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Company Management"
            breadcrumbItem="Companies & Users"
          />

          <Row>
            <Col lg="12">
              <CompaniesTable />
            </Col>
          </Row>
{
  /*
      <Row className="mt-4">
            <Col lg="12">
              <CompanyPartnerUsers />
            </Col>
          </Row>
   */
}
      
        </Container>
      </div>
      <ToastContainer />
    </>
  );
}

export default CompanyManagement;
